import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  height: 94vh;
  overflow: scroll;
  width: 100%;
  margin: 16px 16px 16px 0;
  padding: 24px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.04), 0 4px 20px rgba(0, 0, 0, 0.06);
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`;

const UserLevelPage = () => {
  return <Container>회원 등급 관리 개발 예정</Container>;
};

export default UserLevelPage;
